#import "../NoteFields.graphql"

mutation createHifoCascadePitchNote(
  $hifoCascadePitchId: ID!
  $content: String!
) {
  createHifoCascadePitchNote(
    input: { hifoCascadePitchId: $hifoCascadePitchId, content: $content }
  ) {
    pitchNote {
      ...NoteFields
    }
  }
}
